module.exports = __webpack_public_path__ + "img/环境管理体系认证证书（英文版）.d946d405.png";